<div class="page full-height gray-font-color font-family bodyBackground">
  @if (!isContentReady) {
    <app-loading-gif></app-loading-gif>
  }
  @if (isContentReady) {
    <div>
      @if (!readOnly) {
        <div>
          <div class="header-navigation-back ">
            <mat-icon data-test="back-arrow-icon" (click)="navigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
            <span class="title">Shipment Details</span>
          </div>
          <div class="shipment-header">
            <div class="shipment-header-content">
              <div class="shipment-info">
                <div class="shipment-label">Shipment ID</div>
                <div class="shipment-id">{{ shipment.shipmentID || '-' }}</div>
              </div>
              <div class="status-info">
                <div class="status-label">Status</div>
                <div [ngClass]="[getShipmentStatusClass(), 'status-badge']">
                  {{ shipment?.status === 'out for delivery' ? 'In Transit' : (shipment?.status | titlecase) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <mat-divider></mat-divider>
      <div class="shipment-stops-container margin-top-sm">
        <div class="stops">Stops ({{ this.statusComplete }}/{{ stops?.length || '0' }})</div>
      </div>
      @for (stop of stops; track stop; let i = $index) {
        <div class="stop-card-container">
          <div class="stop-card" data-test="shipment-stops-cotainer">
            <div class="stop-header" 
                 [ngClass]="{'completed-stop-header': stop.status === STATUS_COMPLETE}"
                 (click)="toggleCardContent(i)"
                 [attr.aria-expanded]="expandedCards.includes(i)">
              <div class="stop-number">
                {{ stop?.setOrder ? stop?.setOrder.toString().padStart(2, '0') : '-' }}
              </div>
              <div class="stop-title-section">
                <div class="stop-name">{{ getStopName(stop?.stopType) || '-' }}</div>
                <div class="stop-duration">Duration: {{ getTime(stop.stopDuration) }}</div>
              </div>
              <div class="header-toggle-icon">
                <mat-icon [class.expanded]="expandedCards.includes(i)">
                  {{ expandedCards.includes(i) ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </div>
            </div>
            @if (expandedCards.includes(i)) {
              <div class="stops-detail-box">
                <div class="content">
                  <div
                    class="left-indicator"
                [ngClass]="{
                  'left-piece-order-1': activeStop === i && stop.status !== STATUS_COMPLETE,
                  'left-piece': activeStop !== i && stop.status !== STATUS_COMPLETE,
                  'left-piece-complete': stop.status === STATUS_COMPLETE
                }"
                  ></div>
                  <div class="content-area">
                      <div class="sub-row">
                        <div class="date-container">
                          <span class="date">
                            <strong>{{ stop?.convertedDate || '-' }} {{ stop?.convertedTime || '-' }}</strong>
                          </span>
                        </div>
                      </div>
                      <div class="sub-row">
                        <div class="location-driver-row">
                          <div class="location-info">
                            @if (stop?.stopType !== 'borderCross') {
                              <div>
                                <strong>
                                  <span class="stops-location">
                                    {{ stop?.city || '-' }}, {{ stop?.state || '-' }}, {{ stop?.country || '-' }}
                                  </span>
                                </strong>
                                <div class="stops-zipcode">
                                  {{ stop?.streetAddress || '-' }}, {{ stop?.zipcode || '-' }}
                                </div>
                              </div>
                            }
                            @if (stop?.stopType === 'borderCross') {
                              <div>
                                <strong>
                                  <span class="stops-location">
                                    {{ stop?.borderCrossingPort ? stop?.borderCrossingPort.replace(',', ', ') : '-' }}
                                  </span>
                                </strong>
                                <div class="stops-zipcode">{{ stop?.entryNumber || '-' }}</div>
                              </div>
                            }
                          </div>
                          <div class="driver-info">
                            @for (driver of stop.assignee; track driver) {
                              <div>
                                <strong>
                                  <span class="stops-location">
                                    {{ getDriverName(driver) }}
                                  </span>
                                </strong>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      <div class="sub-row margin-top-sm">
                        <div class="vehicle-info-row">
                          <div class="unit-info" [class.single-trailer]="stop.trailers?.length === 1">
                            <span class="stops-zipcode">
                              Unit
                            </span>
                            <div>
                              <strong>
                                <span class="stops-location">
                                  {{ getUnitNumber(stop?.vehicle, true) }}
                                </span>
                              </strong>
                            </div>
                          </div>
                          @for (trailer of stop.trailers; track trailer; let j = $index) {
                            <div class="trailer-info" [class.single-trailer]="stop.trailers?.length === 1">
                              <span class="stops-zipcode"> 
                                Trailer @if (stop.trailers?.length > 1) {
                                  <span>{{ j + 1 }}</span>
                                } 
                              </span>
                              <div>
                                <strong>
                                  <span class="stops-location">
                                    {{ getUnitNumber(trailer, false) }}
                                  </span>
                                </strong>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <div class="button-row">
                <button 
                  class="details-toggle-btn"
                  (click)="toggleDetailSection(i, stop.id)"
                  [attr.aria-expanded]="selectedStopIndices.includes(i)"
                  data-test="show-details-button">
                  <span class="btn-text">{{ selectedStopIndices.includes(i) ? 'Hide Details' : 'Show Details' }}</span>
                  <mat-icon class="toggle-icon" [class.expanded]="selectedStopIndices.includes(i)">
                    {{ selectedStopIndices.includes(i) ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                </button>
              </div>
              @if (selectedStopIndices.includes(i)) {
                <div (click)="$event.stopPropagation()">
                  <div class="stop-details-container">
                    <div class="left-line"></div>
                    <div class="details-content">
                      <div class="instruction-box margin-top-md">
                        @if (stop?.instructions && stop.instructions.trim()) {
                          <p class="instructions">
                            <strong class="business-value">Instructions:</strong>
                            <span class="instruction-text">{{ stop.instructions }}</span>
                          </p>
                        } @else {
                          <p class="instructions no-instructions">
                            <mat-icon class="instruction-icon">info_outline</mat-icon>
                            <span class="no-instruction-text">No specific instructions provided for this stop</span>
                          </p>
                        }
                      </div>
                      <div class="border-cross-type">
                        @if (stop?.stopType === 'borderCross') {
                          <div class="detail-row margin-bottom-sm margin-top-md">
                            <div class="business-title wrap-text">Border Crossing Port</div>
                            <div class="business-value wrap-text">
                              {{ stop?.borderCrossingPort ? stop?.borderCrossingPort.replace(',', ', ') : '-' }}
                            </div>
                          </div>
                        }
                      </div>
                      <div>
                        @if (stop?.stopType !== 'borderCross') {
                          <div class="contact-details-section margin-top-md">
                            @if (
                              stop.stopType === 'pickupLoad' ||
                              stop.stopType === 'hookTrailer' ||
                              stop.stopType === 'deliverLoad' ||
                              stop.stopType === 'dropTrailer'
                              ) {
                              <div class="shipper-consignee-row margin-bottom-md">
                                <div class="business-title wrap-text">{{ getShipperOrConsignee(stop.stopType) }}</div>
                                <div class="business-value wrap-text">{{ stop?.shipperConsigneeName || '-' }}</div>
                              </div>
                            }
                            <div class="contact-fields-row">
                              <div class="contact-field">
                                <div class="business-title wrap-text">Contact Email</div>
                                <div class="business-value wrap-text">{{ stop?.contactEmail || '-' }}</div>
                              </div>
                              <div class="contact-field">
                                <div class="business-title wrap-text">Contact Name</div>
                                <div class="business-value wrap-text">{{ stop?.contactName || '-' }}</div>
                              </div>
                              <div class="contact-field">
                                <div class="business-title wrap-text">Contact Phone</div>
                                <div class="business-value wrap-text">{{ stop?.contactPhone || '-' }}</div>
                              </div>
                            </div>
                          </div>
                        }
                        @if (stop?.stopType === 'borderCross') {
                          <div class="border-cross-details margin-top-md">
                            <div class="border-cross-row">
                              @if (stop?.aceEManifestNumber || stop?.aciEManifestNumber) {
                                <div class="manifest-info">
                                  @if (stop?.aceEManifestNumber) {
                                    <div class="margin-bottom-sm">
                                      <div class="business-title wrap-text">ACE eManiefest Number</div>
                                      <div class="business-value wrap-text">{{ stop?.aceEManifestNumber || '-' }}</div>
                                    </div>
                                  }
                                  @if (stop?.aciEManifestNumber) {
                                    <div>
                                      <div class="business-title wrap-text">ACI eManiefest Number</div>
                                      <div class="business-value wrap-text">{{ stop?.aciEManifestNumber || '-' }}</div>
                                    </div>
                                  }
                                </div>
                              }
                              <div class="entry-info">
                                <div class="business-title wrap-text">Entry Number</div>
                                <div class="business-value wrap-text">{{ stop?.entryNumber || '-' }}</div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="button-row">
                    @if (!(stop.stopType === 'borderCross') && !readOnly) {
                      <div>
                        @if (
                          !(stop.stopType === PICKUP_LOAD || stop.stopType === DELIVER_LOAD) &&
                          showUploadButton(stop) &&
                          disableHookTrailerUpload(stop) &&
                          disableDropTrailerUpload(stop)
                          ) {
                          <button
                            class="full-width pending"
                            mat-raised-button
                            type="submit"
                            (click)="openActionSheet(stop.id, stop.stopType)"
                            [disabled]="isButtonDisabled(i)"
                            data-test="upload-document-button"
                            >
                            Upload {{ stop?.documentUploadName }}
                          </button>
                        }
                        @if (
                          ((stop.stopType === PICKUP_LOAD && stop?.document?.type !== 'BillOfLading') ||
                          (stop.stopType === DELIVER_LOAD && stop?.document?.type !== 'ProofOfDelivery')) &&
                          shouldDisplayButton(stop)
                          ) {
                          <button
                            class="full-width pending"
                            mat-raised-button
                            type="submit"
                            (click)="openActionSheet(stop.id, stop.stopType)"
                            [disabled]="isButtonDisabled(i)"
                            data-test="upload-document-button"
                            >
                            Upload {{ stop?.documentUploadName }}
                          </button>
                        }
                      </div>
                    }
                    @if (stop.stopType === 'borderCross' && !readOnly) {
                      <div>
                        @if (stop?.document?.type !== 'ACIeManifest' && stop?.document?.role !== 'Dispatcher') {
                          <button
                            class="full-width pending"
                            mat-raised-button
                            type="submit"
                            (click)="openActionSheet(stop.id, stop.stopType, 'ACIeManifest')"
                            [disabled]="isButtonDisabled(i)"
                            data-test="upload-document-button"
                            >
                            Upload Stamped ACI eManifest
                          </button>
                        }
                        @if (stop?.document?.type !== 'ACEeManifest' && stop?.document?.role !== 'Dispatcher') {
                          <button
                            class="full-width pending margin-top-sm"
                            mat-raised-button
                            type="submit"
                            (click)="openActionSheet(stop.id, stop.stopType, 'ACEeManifest')"
                            [disabled]="isButtonDisabled(i)"
                            data-test="upload-document-button"
                            >
                            Upload Stamped ACE eManifest
                          </button>
                        }
                        @if (stop?.document?.type === 'ACIeManifest' && stop?.document?.role !== 'Dispatcher') {
                          <button
                            class="full-width view-document"
                            mat-raised-button
                            type="submit"
                            (click)="viewUploadedDocument(stop?.document.id)"
                            data-test="view-document-button"
                            >
                            View Stamped ACI eManifest
                          </button>
                        }
                        @if (stop?.document?.type === 'ACEeManifest' && stop?.document?.role !== 'Dispatcher') {
                          <button
                            class="full-width view-document"
                            mat-raised-button
                            type="submit"
                            (click)="viewUploadedDocument(stop?.document.id)"
                            data-test="view-document-button"
                            >
                            View Stamped ACE eManifest
                          </button>
                        }
                        @if (
                          (stop?.document?.type === 'ACEeManifest' || stop?.document?.type === 'ACIeManifest') &&
                          stop.status !== STATUS_COMPLETE
                          ) {
                          <button
                            class="full-width complete"
                            mat-raised-button
                            type="submit"
                            (click)="changeStopStatus(stop, STATUS_COMPLETE)"
                            data-test="stop-complete-button"
                            >
                            Complete
                          </button>
                        }
                      </div>
                    }
                    @if (stop.stopType !== 'borderCross' && !readOnly) {
                      <div>
                        @if (
                          !stop?.document &&
                          (stop.stopType === DELIVER_LOAD || stop.stopType === PICKUP_LOAD) &&
                          stop.status === STATUS_PENDING
                          ) {
                          <button
                            class="full-width complete"
                            mat-raised-button
                            type="submit"
                            (click)="changeStopStatus(stop, getButtonName(stop?.stopType))"
                            [disabled]="isButtonDisabled(i)"
                            data-test="loading-unloading-button"
                            >
                            {{ getButtonName(stop?.stopType) | titlecase }}
                          </button>
                        }
                        @if (stop?.document) {
                          <button
                            class="full-width view-document"
                            mat-raised-button
                            type="submit"
                            (click)="viewUploadedDocument(stop?.document.id)"
                            data-test="view-document-button"
                            >
                            View {{ stop?.documentDisplayName }}
                          </button>
                        }
                        @if (
                          (((stop?.document && stop?.document?.status === 'uploaded') ||
                          this.disableDocumentUpload.includes(stop.stopType) ||
                          !disableHookTrailerUpload(stop) ||
                          !disableDropTrailerUpload(stop)) &&
                          stop.status !== STATUS_COMPLETE) ||
                          (stop?.document &&
                          stop?.document?.status === 'uploaded' &&
                          ((stop.stopType === PICKUP_LOAD && stop?.document?.type === 'BillOfLading') ||
                          (stop.stopType === DELIVER_LOAD && stop?.document?.type === 'ProofOfDelivery')) &&
                          stop.status !== STATUS_COMPLETE)
                          ) {
                          <button
                            class="full-width complete"
                            mat-raised-button
                            type="submit"
                            (click)="changeStopStatus(stop, STATUS_COMPLETE)"
                            [disabled]="isButtonDisabled(i)"
                            data-test="stop-complete-button"
                            >
                            Complete
                          </button>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  }
</div>